export default "__VITE_ASSET__d01b919c__"